import React from 'react'
import { DrawerContentBody, DrawerContentFooter, DrawerContentHeader } from '@components/foundation/drawer/Drawer'
import { Skeleton } from '@components/foundation/skeleton/Skeleton'
import styles from '../styles/LoadingSkeleton.module.scss'

type BaseSkeletonProps = {
  sectionCount?: number
}

export const LoadingSkeleton: React.FC<BaseSkeletonProps> = ({ sectionCount = 4 }) => {
  return (
    <>
      <DrawerContentHeader>
        <div className={styles.heading}>
          <Skeleton variant="text" className={styles.title} />
          <Skeleton variant="text" className={styles.description} />
        </div>
      </DrawerContentHeader>
      <DrawerContentBody>
        <SectionsSkeleton sectionCount={sectionCount} />
      </DrawerContentBody>
      <DrawerContentFooter>
        <Skeleton className={styles.footer} />
      </DrawerContentFooter>
    </>
  )
}

const SectionsSkeleton: React.FC<BaseSkeletonProps> = ({ sectionCount = 2 }) => {
  return (
    <div className={styles.container}>
      {Array.from({ length: sectionCount }).map((_, index) => (
        <Skeleton key={index} className={styles.section} />
      ))}
    </div>
  )
}
